import { useState } from "react";
import DhlOptions from "./DhlOptions";
import UpsOptions from "./UpsOptions";

export default function ShippingTypeTabs({
  shippingAddress,
  setShippingAddress,
  checkMarks,
  setCheckMarks,
  getTransitDays,
  validateAddress,
}) {
  /*   All States
   ********************************************* */
  const [activeTab, setActiveTab] = useState("UPS");

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  return (
    <div>
      {/*   Tabs List
       ********************************************* */}
      <div className="rounded-lg mb-2" style={{ width: "fit-content" }}>
        <button
          onClick={() => setActiveTab("UPS")}
          type="button"
          className={`btn  ${
            activeTab === "UPS" ? "btn-primary" : "btn-light"
          }`}
        >
          UPS
        </button>
        <button
          onClick={() => setActiveTab("DHL")}
          type="button"
          className={`btn  ${
            activeTab === "DHL" ? "btn-primary" : "btn-light"
          }`}
        >
          DHL
        </button>
      </div>

      {/*   Tabs Content
       ********************************************* */}
      {shippingAddress && activeTab === "UPS" && (
        <UpsOptions
          shippingAddress={shippingAddress}
          setShippingAddress={setShippingAddress}
          checkMarks={checkMarks}
          getTransitDays={getTransitDays}
          validateAddress={validateAddress}
        />
      )}
      {shippingAddress && activeTab === "DHL" && (
        <DhlOptions
          shippingAddress={shippingAddress}
          setShippingAddress={setShippingAddress}
          checkMarks={checkMarks}
          setCheckMarks={setCheckMarks}
        />
      )}
    </div>
  );
}
